import RecconectingWebSocket from 'reconnecting-websocket';
class SocketStream {
	constructor() {
		this.socket = null;
		this.onConnectList = [];
		this.connected = false;
		// callbacks for all messages
		this.messageHandlers = {};
		// callbacks for channel messages
        this.channelHandlers = {};
        this.result = null;
    }
    readFile(file) {
        let arr = new Promise ((resolve, reject) => {
            let reader = new FileReader();
            reader.onload = (event)=>{
                resolve(event.target.result);
            };
            reader.onerror = (event)=>{
                reject(event);
            };
            reader.readAsArrayBuffer(file);
        });
        return arr;
    }
    handHakeRandom() {
        return Math.random()
    }
    handlerMessage(message) {
        for (let key in this.messageHandlers)
            this.messageHandlers[key](dataObj);
        if (message.length !== 2) return; // [ channel, {} ] or [ channel, []]
        let channel = message[0];
        let payload = message[1];
        if (typeof channel !== 'string') return;
        if (this.channelHandlers[channel]) {
            for (let key in this.channelHandlers[channel]) {
                this.channelHandlers[channel][key](payload);
            }
        }
    }
	connect(uri) {
		this.socket = new RecconectingWebSocket(uri + `LiveStream?id=${this.handHakeRandom()}`);
		this.socket.onopen = () => {
			this.connected = true;
			for (let i = 0; i < this.onConnectList.length; i++)
                this.onConnectList[i]();
		};
		this.socket.onclose = (event) => {
            if (event.wasClean) {
                console.log('Соединение закрыто чисто');
            }
            else {
                console.log('Обрыв соединения'); 
                console.log('Код: ' + event.code + ' причина: ' + event.reason);
            }
		}
		this.socket.onmessage = (msg) => {
            //console.log('Got message: ' + msg.data)
            const pako = require('pako');
            this.readFile(msg.data)
            .then(
                result => {
                    let arr = new Uint8Array(result);
                    let decomArr = pako.inflate(arr, { to: 'string' });
                    let dataObj = ['Statistics']
                    dataObj.push(JSON.parse(decomArr));
                    this.handlerMessage(dataObj);                    
                },
                error => {
                    let dataObj = JSON.parse(msg.data);
                    this.handlerMessage(dataObj); 
                }
            )
        }
	}

	addMessageHandler(id, handler) {
		this.messageHandlers[id] = handler;
	}

	removeMessageHandler(id) {
		delete this.messageHandlers[id];
	}

	addChannelHandler(channel, id, handler) {
		if (!this.channelHandlers[channel])
			this.channelHandlers[channel] = {};
		this.channelHandlers[channel][id] = handler;
	}

	removeChannelHandler(channel, id) {
		if (!this.channelHandlers[channel]) return;
		delete this.channelHandlers[channel][id];
	}

	subscribeOnConnect(handler) {
		if (this.connected) {
			handler();
			return;
		}
		this.onConnectList.push(handler);
	}

	subscribeOnQuotes(onAll, selectedQuotes){
		let subMsg = JSON.stringify({
			ClassName: "QuoteSubscription",
			SubscribeOnAll: onAll,
			Quotes: selectedQuotes
		});
		this.subscribeOnConnect(() => {
			this.socket.send(subMsg);
		});
	}
}

export let socketStream = new SocketStream();
